import { z } from 'zod';
import { MILESTONE_STATES } from './milestones.js';
import { WORKLOAD_STATES } from './pages.js';
const nextMilestone = z.object({
    id: z.string(),
    title: z.string(),
    dateLabel: z.string(),
    state: z.enum(MILESTONE_STATES),
    done: z.number(),
    total: z.number(),
    forecastLabel: z.string(),
});
const builtLine = z.object({ ref: z.string(), title: z.string(), url: z.string() });
const person = z.object({ userId: z.string(), name: z.string(), initials: z.string(), avatarColour: z.string(), roleLine: z.string(), href: z.string() });
/** The list of projects (PRJ-7), as of now with this week's figures. */
export const projectsListResponseSchema = z.object({
    /** "week of 21 September" */
    weekLabel: z.string(),
    /** False until the first counting run has written the projects set. */
    recorded: z.boolean(),
    /** Every bar in Open work shares this scale: the largest project's total. */
    scale: z.number(),
    projects: z.array(z.object({
        slug: z.string(),
        name: z.string(),
        /** Where its work lives, e.g. "shaw-platform · stories" or "Teamwork · H2H Spark". */
        source: z.string(),
        open: z.object({ counts: z.record(z.enum(WORKLOAD_STATES), z.number()), total: z.number() }),
        nextMilestone: nextMilestone.nullable(),
        builtThisWeek: z.number(),
        toProductionThisWeek: z.number(),
        /** Items still to do on its at-risk or late milestones. */
        atRisk: z.number(),
        /** The latest things built on it this week, three at most. */
        latestBuilt: z.array(builtLine),
        people: z.array(person),
    })),
});
/** A project's Overview (PRJ-8). */
export const projectOverviewResponseSchema = z.object({
    weekLabel: z.string(),
    product: z.object({ slug: z.string(), name: z.string(), source: z.string(), hasBoard: z.boolean(), hasStories: z.boolean() }),
    tiles: z.object({
        built: z.number(),
        merged: z.number(),
        toProduction: z.number(),
        /** Null for a project with no story repository. */
        waitingForAcceptance: z.number().nullable(),
    }),
    milestones: z.array(nextMilestone.extend({ source: z.enum(['Pulse', 'Teamwork']), talosLine: z.string().nullable() })),
    /** The latest things built on it this week, five at most. */
    thisWeek: z.array(builtLine),
    people: z.array(person),
    atRisk: z.number(),
    /** What the latest followed meeting said about it; null when none has (MT-4). */
    latestMeeting: z.object({ title: z.string(), whenLabel: z.string(), summary: z.string() }).nullable(),
});
//# sourceMappingURL=projects.js.map